import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { SnackbarProvider } from "notistack";
import Navigation from "./navigation";
import { SnackbarUtilsConfigurator } from "./scripts/snackbar";

export const themeOptions = {
  palette: {
    type: "light",
    primary: {
      main: "#FF1A3D",
      contrastText: "#fff",
    },
    secondary: {
      main: "#666",
    },
    tertiary: {
      main: "#FF7589",
    },
    text: {
      //primary: "white",
      primary: "#000000",
      grey: "#999999",
    },
    background: {
      default: "#F5F5F5",
      border: "#EDEDEE",
    },
    // Adding these as a fallback
    success: { main: "#26d43a" },
    warning: { main: "#fcb447" },
    info: { main: "#737171", contrastText: "#fff" },
    error: { main: "#c53c3c" },
    critical: { main: "#DC4EF2", contrastText: "#fff" },
    unknown: { main: "#bbb", contrastText: "#fff" },
    // , but we mainly switched to use AlertColors instead in the alert_enums

    grid: {
      main: "#ee7486",
      secondary: "#66D7B7",
    },
    grid_reference_max_offtake: {
      main: "#000000",
    },
    consumption: {
      main: "#FF1A3D",
      secondary: "#FF7589",
    },
    actuals: {
      main: "#E6443A",
      withElion: "#F4A261",
    },
    production: {
      main: "#66D7B7",
      secondary: "#999",
      dark: "#009975",
    },
    curtailment: {
      main: "#999",
    },
    flex: {
      main: "#fcba03",
    },
    flex_charge: {
      main: "#fcba03",
      secondary: "#FFF176",
    },
    flex_discharge: {
      main: "#ff8a18",
      secondary: "#FFCC80",
    },
    inverterLoss: {
      main: "#fc7cf2",
    },
    soc: {
      main: "#009975",
      secondary: "rgba(25, 118, 210, 0.30)"
    },
    naturalPeak: {
      main: "#043b64",
      gray: "#666f75",
    },
    drawnPeak: {
      main: "#7697a0",
      gray: "#979fa1",
    },
    setPeak: {
      main: "#000",
    },
    imbPrice: {
      main: "#999",
    },
    lynx: {
      main: "#FF1A3D",
      secondary: "#666",
    },
  },
};

function App() {
  const theme = createTheme(themeOptions);

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3} autoHideDuration={3000} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <SnackbarUtilsConfigurator />
        <CssBaseline />
        <Navigation />
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
